import * as React from 'react'

import { useVerificationRequestsWidget } from './hooks'
import { VerificationRequest } from './types'
import {
  CBadge,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
} from '@coreui/react-pro'
import { Alert, Card } from 'antd'
import { getBadge } from '../../const'
import { path } from '../../../../libs'
import { CheckCircleOutlined, CloseSquareOutlined } from '@ant-design/icons'

type Props = {
  clientId: string
}

export const DuplicatesWidget = ({ clientId }: Props) => {
  const { verificationRequest } = useVerificationRequestsWidget(clientId)

  return (
    <>
      <CCard>
        <CCardHeader>Duplicates</CCardHeader>
        <CCardBody>
          <VerificationRequestsList items={verificationRequest} />
        </CCardBody>
      </CCard>
    </>
  )
}

//

type VerificationRequestsListProps = {
  items: VerificationRequest[] | undefined
}

const VerificationRequestsList = ({ items }: VerificationRequestsListProps) => {
  return (
    <>
      {items &&
        items?.length > 0 &&
        items?.map((item) => {
          return (
            <Card className="mb-2" key={item.requestId} title={item.updatedAt}>
              <CRow>
                <CCol>
                  verify request:
                  <a
                    href={path.verificationsV2.details(item.requestId)}
                    target="_blank"
                  >
                    {item.requestId}
                  </a>
                </CCol>
                <CCol>
                  <p>
                    client ID:
                    <a
                      href={path.clients.details(item.clientId)}
                      target="_blank"
                    >
                      {item.clientId}
                    </a>
                  </p>
                  <p>
                    Full name: {item.firstName} {item.lastName}
                  </p>
                  <p>Birth date: {item.dateOfBirth}</p>
                  <p>Email: {item.client.email}</p>
                  <p>
                    Is verified:{' '}
                    {item.client.verified ? (
                      <CheckCircleOutlined className={'text-success'} />
                    ) : (
                      <CloseSquareOutlined className={'text-danger'} />
                    )}
                  </p>
                </CCol>
                <CCol>
                  <CBadge color={getBadge(item.status)} className={'mb-1'}>
                    {item.status}
                  </CBadge>
                </CCol>
                <CCol>documentNumber: {item.documentNumber}</CCol>
                <CCol>
                  <p>reason: {item.reason}</p> <p>comment: {item.comment}</p>
                </CCol>
              </CRow>
            </Card>
          )
        })}
    </>
  )
}
